import React,{ Component } from "react";
import { connect } from "react-redux";
import { getLdap, deleteLdap, testLdapConfig,setLdapPageInfo } from "../../actions/actionLdap";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Button, Modal, ModalHeader,  Form, 
    FormGroup, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import { withRouter } from "react-router-dom";
import "react-table/react-table.css";
import { renderField, required } from "../../utils/formValidations.js";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Ldap",path:"/ldap",isActive: true}
];

class Ldap extends Component{
    constructor(props){
        super(props);

        this.state = {
            modal: false,
            modalldap: false,
            pages: 1,
            ldapId: null,
            password: "",
        };

        this.ldapConfirm = this.ldapConfirm.bind(this);
        this.submitLdapConfig = this.submitLdapConfig.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteLdapAction = this.deleteLdapAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.toggle1 = this.toggle1.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
    }

    ldapConfirm(ldapId){
        this.setState({modalldap: !this.state.modalldap,
            ldapId: ldapId
        });
    }

    submitLdapConfig(userData){
        let currentLdap = this.props.ldap_configs.find(ldap => ldap.ldap_id === this.state.ldapId);
        currentLdap.ldapId = this.state.ldapId,
        currentLdap.username = userData.username;
        currentLdap.password = userData.password;
        this.props.testLdapConfig(currentLdap).
            then(() => this.handleLdapConfigSuccess()).
            catch(() => this.handleLdapConfigFailure());
    }

    handleLdapConfigSuccess(){
        const {TestLdapConfigErrorMessage} = this.props; 
        if(TestLdapConfigErrorMessage){
            NotificationManager.error(TestLdapConfigErrorMessage,"Test LDAP Config", 3000);
        }
        else{
            NotificationManager.success("Test LDAP", "TEST LDAP Config Successfully");
            this.setState({modalldap: false});
        }
    }

    handleLdapConfigFailure(){
        const {TestLdapConfigError} = this.props;
        if(TestLdapConfigError){
            NotificationManager.error(TestLdapConfigError,"Create Group", 3000);
        }
        else{
            NotificationManager.error("Something Went Wrong!!", "Test LDAP Failed");
            this.setState({modalldap: false});
        }
    }

    componentDidMount() {
        this.props.getLdap();
    }

    deleteConfirm(ldapId){
        this.setState({modal: !this.state.modal,
            ldapId: ldapId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    toggle1(){
        this.setState({modalldap: !this.state.modalldap});
        this.props.initialize({ username: "", password: "" });
    }

    deleteLdapAction(){
        this.props.deleteLdap(this.state.ldapId).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }   

    handleDeleteSuccess(){
        const {deleteLdapErrorMessage} = this.props;
        if(deleteLdapErrorMessage) {
            NotificationManager.error(deleteLdapErrorMessage,"Failed to Delete Ldap", 3000);
        }else{
            NotificationManager.success("Ldap Deleted Successfully","Delete Ldap", 3000);
            this.setState({modal: false});
            this.props.getLdap();
        }
    }

    handleDeleteError(){
        const {deleteLdapError} = this.props;
        if(deleteLdapError){
            NotificationManager.error(deleteLdapError,"Failed to Delete Ldap", 3000);
            this.props.history.push("/ldap");
        }else{
            NotificationManager.error("Failed to Delete Ldap","Delete Ldap", 3000);
            this.props.history.push("/ldap");
        }
    }

    render(){
        if (this.props.getLdapLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const { ldap_configs, handleSubmit } = this.props;
            
        const tableColumns = [
            {
                type: "text",
                name: "Name",
                accessor: "name",
                filterable: true,
                sortable: true,
            },
            {
                type: "text",
                name: "LDAP URL",
                accessor: "url",
                filterable: true,
                sortable: true,
            }
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
            { id: "test", icon: "fa-key", description: "Test LDAP Connection" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewldap/${item.ldap_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updateldap/${item.ldap_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.ldap_id);
                break;

                case "test":
                    this.ldapConfirm(item.ldap_id);
                break;
            }
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/> 
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-book"></i> <strong>LDAP Configurations</strong>
                                </div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createldap" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                    Add Configuration
                                    </button>
                                </Link> 
                            </CardHeader>
                            <CardBody className="p-0">
                                 <DataTable
                                    id="ldap"
                                    data={ldap_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modalldap} toggle1={this.toggle1} centered={true} className="user-modal"> 
                    <Form onSubmit={handleSubmit(this.submitLdapConfig)}>
                        <ModalHeader toggle1={this.toggle1}>Test LDAP Connection
                        </ModalHeader>
                        <ModalBody>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <label className="requiredasterisk"> Test User Name </label>
                                    </Col>
                                    <Col>
                                        <Field 
                                            id="username"
                                            type="username"
                                            name="username"
                                            component={renderField} 
                                            validate={[required]}
                                        /> 
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <label className="requiredasterisk">Test Password </label>
                                    </Col>
                                    <Col>
                                        <Field
                                            id="password"
                                            type="password"
                                            name="password"
                                            component={renderField}
                                            validate={[required]}
                                        />                                            
                                    </Col>
                                </Row>
                            </FormGroup> 
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={this.toggle1} size="sm"
                            className="cancel-button"
                            color="basic">Cancel</Button>
                            <Button type="submit" size="sm" 
                            className="submit-button" 
                            color="primary">Test Connection</Button>
                        </ModalFooter>
                    </Form>  
                </Modal>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm"
                        className="cancel-button" color="basic">Close</Button>
                        <Button onClick={this.deleteLdapAction} 
                         className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Ldap.propTypes = {
    getLdap: Proptypes.func.isRequired,
    deleteLdap: Proptypes.func.isRequired,
    deleteLdapErrorMessage: Proptypes.func,
    TestLdapConfigErrorMessage: Proptypes.string,
    testLdapConfig: Proptypes.func.isRequired,
    deleteLdapError: Proptypes.func,
    history: Proptypes.object.isRequired,
    ldap: Proptypes.array,
    getLdapLoading: Proptypes.bool,
    initialize: Proptypes.func,
    ldap_configs: Proptypes.array,
    handleSubmit:  Proptypes.func,
    className: Proptypes.func,
    TestLdapConfigError: Proptypes.string
};

let  LdapFormWithRouter = withRouter(Ldap);

let LdapForm = connect(state => ({
    ldap_configs: state.ldap_configs.ldap_configs || [],
    getLdapLoading: state.ldap_configs.getLdapLoading || false,
    deleteLdapErrorMessage: state.ldap_configs.deleteLdapErrorMessage || null,
    deleteLdapLoading: state.ldap_configs.deleteLdapLoading || false,
    deleteLdapError: state.ldap_configs.deleteLdapError || null,
    TestLdapConfigErrorMessage: state.ldap_configs.TestLdapConfigErrorMessage || null,
    TestLdapConfigLoading: state.ldap_configs.TestLdapConfigLoading || null,
    pages : {pageSize : state.ldap_configs.pageSize, pageNo : state.ldap_configs.pageNo},
}), 
dispatch => ({
    getLdap: () => dispatch(getLdap()),
    testLdapConfig: (data) => dispatch(testLdapConfig(data)),
    deleteLdap: (data) => dispatch(deleteLdap(data)),
    setPageInfo : (data)=> dispatch(setLdapPageInfo(data)),
}))(LdapFormWithRouter);

export default reduxForm({
    form: "ldapForm",
})(LdapForm);